import { cn } from "../../classNames-DkX30VJU.js";
import { BrandLogo } from "../../BrandLogo-DZLi6TZV.js";
import { jsx, jsxs } from "react/jsx-runtime";
// src/blocks/AuthLayout/AuthLayout.tsx
const widthClass = {
	form: "tw:max-w-md",
	wide: "tw:max-w-[34rem]"
};
/**
* Split-geometry column tracks.
*
* - The form floor is `widthClass` plus `SURFACE`'s gutters; a bare `1fr` would squeeze the form.
*/
const splitClass = {
	form: {
		end: "tw:lg:grid-cols-[minmax(32rem,1fr)_2fr]",
		start: "tw:lg:grid-cols-[2fr_minmax(32rem,1fr)]"
	},
	wide: {
		end: "tw:lg:grid-cols-[minmax(38rem,1fr)_2fr]",
		start: "tw:lg:grid-cols-[2fr_minmax(38rem,1fr)]"
	}
};
const SCREEN = "tw:min-h-svh";
const SURFACE = "tw:flex tw:justify-center tw:px-4 tw:py-12 tw:sm:px-8";
const COLUMN = "tw:flex tw:w-full tw:flex-col tw:items-center tw:gap-6";
const Root = ({ ref, className, width = "form", aside, asideSide = "end", asideCollapse = "hide", children, ...props }) => {
	const column = /* @__PURE__ */ jsx("div", {
		className: cn(COLUMN, widthClass[width]),
		children
	});
	if (!aside) return /* @__PURE__ */ jsx("div", {
		ref,
		className: cn(SURFACE, SCREEN, "tw:items-center tw:bg-muted", className),
		...props,
		children: column
	});
	const panel = /* @__PURE__ */ jsx("aside", {
		className: cn("tw:bg-muted", asideCollapse === "stack" ? "tw:flex" : "tw:hidden tw:lg:flex"),
		children: aside
	});
	const form = /* @__PURE__ */ jsx("div", {
		className: cn(SURFACE, "tw:bg-background"),
		children: column
	});
	return /* @__PURE__ */ jsxs("div", {
		ref,
		className: cn("tw:grid", SCREEN, splitClass[width][asideSide], className),
		...props,
		children: [asideSide === "start" ? panel : form, asideSide === "start" ? form : panel]
	});
};
const Header = ({ ref, className, actions, productName, children, ...props }) => /* @__PURE__ */ jsxs("header", {
	ref,
	className: cn("tw:flex tw:items-center tw:gap-4", actions && "tw:w-full tw:justify-between", className),
	...props,
	children: [children ?? /* @__PURE__ */ jsxs("span", {
		className: "tw:flex tw:items-center tw:gap-3",
		children: [/* @__PURE__ */ jsx(BrandLogo, {
			variant: "mark",
			className: "tw:h-8 tw:text-primary"
		}), /* @__PURE__ */ jsx("span", {
			className: "tw:text-lg tw:font-semibold",
			children: productName
		})]
	}), actions && /* @__PURE__ */ jsx("div", {
		className: "tw:flex tw:items-center tw:gap-1",
		children: actions
	})]
});
const Content = ({ ref, className, children, ...props }) => /* @__PURE__ */ jsx("main", {
	ref,
	className: cn("tw:flex tw:min-h-0 tw:w-full tw:flex-1 tw:flex-col tw:gap-6", className),
	...props,
	children
});
const Footer = ({ ref, className, children, ...props }) => /* @__PURE__ */ jsx("footer", {
	ref,
	className: cn("tw:mt-auto tw:w-full tw:text-xs tw:text-muted-foreground", className),
	...props,
	children
});
/**
* The signed-out page frame — sign-in, sign-up, password reset, MFA, project and stack pickers.
*
* - Owns the `header` / `main` / `footer` landmarks and the brand lockup.
* - No card: wrap the body in `Card` at the call site.
* - Not for navigational signed-out pages (public catalog) — use `AppShell` + `PageLayout`.
*/
const AuthLayout = Object.assign(Root, {
	Header,
	Content,
	Footer
});
export { AuthLayout };

//# sourceMappingURL=AuthLayout.js.map